import { render, staticRenderFns } from "./DetailDoc.vue?vue&type=template&id=8a6fd7ec&scoped=true"
import script from "./DetailDoc.vue?vue&type=script&lang=js"
export * from "./DetailDoc.vue?vue&type=script&lang=js"
import style0 from "./DetailDoc.vue?vue&type=style&index=0&id=8a6fd7ec&prod&scoped=true&lang=css"
import style1 from "./DetailDoc.vue?vue&type=style&index=1&id=8a6fd7ec&prod&scoped=true&lang=css"
import style2 from "./DetailDoc.vue?vue&type=style&index=2&id=8a6fd7ec&prod&scoped=true&lang=css"
import style3 from "./DetailDoc.vue?vue&type=style&index=3&id=8a6fd7ec&prod&scoped=true&lang=css"
import style4 from "./DetailDoc.vue?vue&type=style&index=4&id=8a6fd7ec&prod&scoped=true&lang=css"
import style5 from "./DetailDoc.vue?vue&type=style&index=5&id=8a6fd7ec&prod&scoped=true&lang=css"
import style6 from "./DetailDoc.vue?vue&type=style&index=6&id=8a6fd7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fd7ec",
  null
  
)

export default component.exports